import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "list-container-files" }

import { toRefs, ref } from 'vue'
import FileListItem from '@/components/general/files/FileListItem/FileListItem.vue'
import { FILE } from '@/interfaces/misc.interface'

interface PROPS {
  files: (File | FILE)[]
  selectedIndex: number
}
interface EMITS {
  (e: 'selectFile', file: File | FILE, index: number): void
}

export default /*@__PURE__*/_defineComponent({
  __name: 'FileList',
  props: {
    files: {},
    selectedIndex: {}
  },
  emits: ["selectFile"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const { files = ref([]), selectedIndex = -1 } = toRefs(props)

const emits = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(files), (file, index) => {
      return (_openBlock(), _createBlock(FileListItem, {
        id: index,
        key: index,
        title: file.name,
        selected: index === _unref(selectedIndex),
        onClick: ($event: any) => (emits('selectFile', file, index))
      }, null, 8, ["id", "title", "selected", "onClick"]))
    }), 128))
  ]))
}
}

})